import React from "react";

interface ExpandIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const ExpandIcon: React.FC<ExpandIconProps> = ({ size = 20, color = '#1E1E1E', className, onClick }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M17.5 7.5V2.5H12.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.5 12.5V17.5H7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.5 2.5L11.25 8.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.75 11.25L2.5 17.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
); export default ExpandIcon;

